import { telegramButtonsMetrics } from "../metrics";
import axios from "axios";
import { Category, EmploymentFormat, Education } from "./constants";

const send = () => {
  const formCitizenRequest =
      "https://hermes.smile-tech.study/api/v1/lead?programId=",
    FlowCRM = "https://2025.api.tgu-dpo.ru/citizenrequest/InternalNewRequest";

  const invalidCharsRegex = /[^a-zA-Z0-9.@_-]/; // Разрешённые символы

  $('[type=email]').on('input', function() {
      const inputValue = $(this).val();

      // Проверяем наличие недопустимых символов
      const invalidChars = inputValue.match(invalidCharsRegex);
      const input = $(this).get(0);
      const inputParent = $(this).parent().get(0);

      if (input.classList.contains('form__field--invalid')) {
        input.classList.remove('form__field--invalid');
        inputParent.querySelector('.form__error-container')?.remove();
      }
      const error = {};

      if (invalidChars) {
        error.message = `Недопустимый символ: "${invalidChars[0]}"`;
        input.classList.add('form__field--invalid');

        showError(error, inputParent)
      }
  });

  // Подсказки для ввода почты
  const validDomains = ['yandex.ru', 'mail.ru', 'gmail.com', 'hotmail.com', 'outlook.com'];

  $('[type=email]').on('input', function() {
    const emailInput = $(this);
    const emailValue = emailInput.val();
    const suggestionsDiv = emailInput.siblings('.suggestions');

    const atIndex = emailValue.indexOf('@');
    if (atIndex !== -1) {
        const domainPart = emailValue.slice(atIndex + 1);
        const suggestions = validDomains.filter(domain => domain.startsWith(domainPart));
        suggestionsDiv.empty(); // Очистка предыдущих подсказок

        if (suggestions.length > 0) {
            suggestions.forEach(domain => {
                suggestionsDiv.append(`<span class="suggestion-item">${emailValue.slice(0, atIndex + 1)}${domain}</span>`);
            });
            suggestionsDiv.show();
        } else {
            suggestionsDiv.hide();
        }
    } else {
        suggestionsDiv.hide();
    }
  });

  // Обработчик клика на предложениях
  $(document).on('click', '.suggestion-item', function() {
      const emailInput = $(this).closest('form').find('[type=email]');
      emailInput.val($(this).text()).focus();
      emailInput.siblings('.suggestions').hide();
  });

  /**
   * Валидаторы
   */
  var validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = "Это поле обязательно";
        return false;
      } else {
        return true;
      }
    },
    phone: function (value, error) {
      if (/^((\+7|7|8)\s?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2}))$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный номер телефона";
        return false;
      }
    },
    email: function (value, error) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный email";
        return false;
      }
    },
    birthday: function (value, error) {
      var parts = value.split(".");
      if (
        parts.length != 3 ||
        parts[0].length != 2 ||
        parts[1].length != 2 ||
        parts[2].length != 4
      ) {
        error.message = "Некорректная дата рождения";
        return false;
      }

      return true;
    },
    snils: function (value, error) {
      var snils = value
        .split(/[\-\s]/)
        .join("")
        .trim();
      var result = false;
      if (typeof snils === "number") {
        snils = snils.toString().replace("-", "").trim();
      } else if (typeof snils !== "string") {
        snils = "";
      }
      if (!snils.length) {
        error.message = "СНИЛС пуст";
      } else if (/[^0-9]/.test(snils)) {
        error.message = "СНИЛС может состоять только из цифр";
      } else if (snils.length !== 11) {
        error.message = "СНИЛС может состоять только из 11 цифр";
      } else {
        var sum = 0;
        for (var i = 0; i < 9; i++) {
          sum += parseInt(snils[i]) * (9 - i);
        }
        var checkDigit = 0;
        if (sum < 100) {
          checkDigit = sum;
        } else if (sum > 101) {
          checkDigit = parseInt(sum % 101);
          if (checkDigit === 100) {
            checkDigit = 0;
          }
        }
        if (checkDigit === parseInt(snils.slice(-2))) {
          result = true;
        } else {
          error.message = "Некорректный номер СНИЛС";
        }
      }
      return result;
    },
  };

  /**
   * Показ ошибок в вёрстке
   * @param {Object} error Объект ошибки
   * @param {HTMLElement} field Элемент поля ввода
   */
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement("div");
      errorContainer.textContent = error.message;
      errorContainer.classList.add("form__error-container");
      field.appendChild(errorContainer);
    }
  }

  /**
   * Удаление ошибок из формы
   * @param {HTMLElement} form Форма
   */
  function deleteErrors(form) {
    form.querySelectorAll(".form__error-container").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll(".form__field--invalid").forEach(function (el) {
      el.classList.remove("form__field--invalid");
    });
  }

  /**
   * Валидация формы
   * @param {HTMLElement} form Форма
   * @returns Валидна ли форма
   */
  function validate(form) {
    var result = true;
    Array.from(form.querySelectorAll(".form__field")).forEach(function (
      formField
    ) {
      var error = {};
      var control = formField.querySelector("select, input, textarea");
      if (formField.querySelector(".form__required")) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
          return;
        }
      }
      if (control.id === "snils") {
        if (!validators.snils(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
          return;
        }
      }
      if (control.type === "tel") {
        if (!validators.phone(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }

      if (control.type === "email") {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }
      if (control.id === "birthday") {
        if (!validators.birthday(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }
    });

    let invalidField = document.querySelector(".form__field--invalid");
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    return result;
  }

  /**
   * Установка масок ввода
   */
  function setMasks() {
    $("#phone").mask("+7 (999) 999-99-99", { autoclear: false });
    $("input[type='tel']").mask("+7 (999) 999-99-99", { autoclear: false });
  }

  /**
   * Получение cookie
   */
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /**
   * Отправка данных из формы и url
   * @param {Event} e Событие submit
   */
  function send(form, e) {
    var sendBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]'
    );
    e.preventDefault();
    deleteErrors(form);
    var data = {};
    if (!validate(form)) {
      return;
    }
    sendBtn.disabled = true;
    Array.from(new FormData(form)).forEach(function (formElement) {
      var key = formElement[0];
      var value = formElement[1];
      if (key == "BirthDate") {
        data[key] = value.split(".").reverse().join("-");
      } else if (key == "Region") {
        data[key] = returnRegionName("#Regions option", value);
        data["RegionId"] = value;
      } else if (key == "category") {
        data[key] = Category[value] ? Category[value] : value;
      } else if (key == "EmploymentFormat") {
        data[key] = EmploymentFormat[value] ? EmploymentFormat[value] : value;
      } else if (key == "Education") {
        data[key] = Education[value] ? Education[value] : value;
      } else {
        data[key] = value;
      }
    });

    data["ambassador"] = false;

    if (document.location.pathname == "/webinars") {
      data["IsWebinar"] = true;
    } else {
      data["IsWebinar"] = false;
    }

    // Добавление поля Категории для сайтов unemployed и dismissalrisk
    if (document.location.pathname == "/unemployed") {
      data["category"] = "1";
    }

    if (document.location.pathname == "/dismissalrisk") {
      data["category"] = "11";
    }

    var url = document.location.href;

    var paramsStartIndex = url.indexOf("?");
    try {
      if (paramsStartIndex > -1) {
        url
          .slice(paramsStartIndex + 1, url.length)
          .split("&")
          .map(function (utmString) {
            return utmString.split("=");
          })
          .forEach(function (utmMark) {
            var key = utmMark[0];
            key = key[0].toUpperCase() + key.slice(1, key.length);
            var value = utmMark[1];
            value =
              value.indexOf("#") > -1
                ? value.slice(0, value.indexOf("#"))
                : value;
            data[key] = value;
          });
      }
    } catch(e) {  
      console.log(e);      
    }

    if (!data.Program) {
      const title = document.querySelector(".home__title").textContent;
      let newProgram = title.slice(title.indexOf("«") + 1, title.indexOf("»"));
      data["Program"] = newProgram;
    }

    /* Добавление данных в передачу формы */
    const programList = document.querySelector("#ProgramHome")?.children,
      programHidden = form.querySelector(".program-hidden");

    if (programList && !programHidden) {
      [...programList].forEach((item) => {
        if (data["Program"] == item.value) {
          if (item.getAttribute("operator")) {
            data["Operator"] = item.getAttribute("operator");
          }

          if (item.getAttribute("program_id")) {
            if (item.getAttribute("program_id") == "null" || item.getAttribute("program_id") == null) {
              data["program_id"] = null;
            } else {
              data["program_id"] = Number(item.getAttribute("program_id"));
            }
          }

          if (item.getAttribute("linkrvr")) {
            data["rvr_link"] = item.getAttribute("linkrvr");
          }
        }
      });
    } else {
      if (programHidden.getAttribute("operator")) {
        data["Operator"] = programHidden.getAttribute("operator");
      }

      if (programHidden.getAttribute("program_id")) {
        if (programHidden.getAttribute("program_id") == "null" || programHidden.getAttribute("program_id") == null) {
          data["program_id"] = null;
        } else {
          data["program_id"] = Number(programHidden.getAttribute("program_id"));
        }
      }

      if (programHidden.getAttribute("linkrvr")) {
        data["rvr_link"] = programHidden.getAttribute("linkrvr");
      }
    }

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");

    if (!!roistatCookie) {
      data["RoistatCookie"] = roistatCookie;
    }

    /* Получение UTM меток из cookie */
    if (getCookie("utm_tags")) {
      try {
        getCookie("utm_tags")
        .slice(paramsStartIndex + 1, getCookie("utm_tags").length)
        .split("&")
        .map(function (utmString) {
          return utmString.split("=");
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf("#") > -1
              ? value.slice(0, value.indexOf("#"))
              : value;
          data[key] = value;
        });
      } catch(e) {  
        console.log(e);        
      }
    }

    let ym_uid = getCookie("_ym_uid");
    if (ym_uid) {
      data["ClientId"] = ym_uid;
    }

    data["Landing"] = url.split("?")[0] || url;
    toastr.options.progressBar = true;

    axios
      .post(formCitizenRequest + data["program_id"], data)
      .then(function (result) {
        sendBtn.disabled = false;
        addAdvCakeScript(
          result.data.requestId,
          result.data.programName,
          data.Email
        );

        if (window.yaCounter74433037) {
          yaCounter74433037.reachGoal("FormSubmit");
          ym(74433037,'reachGoal','FormSubmitOnline');
        }

        if (window.yaCounter74433037) {
          yaCounter74433037.reachGoal("ym-submit-leadform");
        }
        // Дополнительный код для фейсбук пикселя
        if (setFBQ) {
          setFBQ(data);
        }
        fbq("track", "Lead");

        // Код для VK пикселя
        VK.Goal("lead");
        VK.Retargeting.Event("lead");
        
        if (data["EmploymentFormat"] === "2") {
          ym(74433037,'reachGoal','submit_form_trud')
        }

        formSubmitFlow(data);
        onSuccess(data);

        form.reset();
        $('#Category').val('').trigger('change');
        $('#Education').val('').trigger('change');
        $('#EmploymentFormat').val('').trigger('change');
        $('#Regions').val('').trigger('change');
        $('#Program').val('').trigger('change');
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;
        toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          { duration: 3000, fadeDuration: 500 }
        );
      });
  }

  /* Отправка формы в АМО */
  function formSubmitFlow(data) {
    data['FirstName'] = data['name'];
    data['Phone'] = data['phone'];
    data['Email'] = data['email'];
    data['LastName'] = '-';
    data["category"] = getKeyByValue(Category, data["category"]);
    data["EmploymentFormat"] = getKeyByValue(EmploymentFormat, data["EmploymentFormat"]);
    data["Education"] = getKeyByValue(Education, data["Education"]);

    axios
      .post(FlowCRM, data)
  }

  /* Полчуние ключа объекта */
  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  } 

  /**
   * Функция для определения вывода модальных окон после успешной отправки формы
   */
  function onSuccess(data = null) {
    let urlRvR = null;

    if (data !== null) {
      if (data.rvr_link && data.rvr_link !== "undefined") {
        urlRvR = data.rvr_link;
      }
    }
    
    if (urlRvR) {
      /* FLOW-12326 */
      // openSuccessModal(urlRvR);
      setTimeout(() => {
        const newTab = window.open(urlRvR, "_blank");
        if (newTab) {
          newTab.focus();
        } else {
          window.location.assign(urlRvR)
        }
        ym(74433037,'reachGoal','click_RR');
        ym(74433037,'reachGoal','wait_redirect');
      }, 0);
    } else {
      openNoRedirectSaveBaseModal();
    }

    toastr.success("Анкета успешно отправлена", "Успех!");

    const container = document.querySelector(".form__container");
    if (container) {
      container.classList.add("success-container");
      container.innerHTML = `<div class="card" style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 3rem;
                max-width: 100%;
            ">
                <h2 class="title" style="text-align: center; margin: 0;">
                Ваша заявка успешно отправлена
                </h2>
            </div>`;
    }
  }

  /**
   * Функция добавления стилей
   */
  function setStyles(el, stylesObject) {
    if (!el) {
      return;
    }
    Object.keys(stylesObject).forEach((key) => {
      el.style[key] = stylesObject[key];
    });
  }

  /**
   * Функция с модальными окнами при успешной отправки фломы
   */
  function successModal() {
    let modal = document.querySelector("#quiz-success");
    if (!modal) {
      modal = document.createElement("div");
      ["modal", "quiz"].forEach((additionalClass) => {
        modal.classList.add(additionalClass);
      });
      modal.id = "quiz-success";
      modal.innerHTML = '<div class="quiz__content"></div>';

      document.body.append(modal);
    }

    const a = document.createElement("a");
    a.href = "#quiz-success";
    a.rel = "modal:open";
    a.style.display = "none";
    document.body.append(a);

    window.openSuccessModal = (url = "") => {
      /* Скачивание инструкции */
      // const downloadInstruction = document.createElement("a");
      // downloadInstruction.href = link;
      // downloadInstruction.setAttribute("download", "");
      // downloadInstruction.style.display = "none";
      // document.body.append(downloadInstruction);
      // downloadInstruction.click();

      /* Скачивание лид магнита */
      // const downloadLead = document.createElement("a");
      // downloadLead.href = "/files/Kak_uvelichit_dohod_v_2024_godu.pdf";
      // downloadLead.setAttribute("download", "");
      // downloadLead.style.display = "none";
      // document.body.append(downloadLead);
      // downloadLead.click();

      const withLink = url.length > 0;
      if (withLink) {
        modal.classList.add("rvr-modal");
        setStyles(modal, {
          position: "relative",
          paddingBottom: "2rem",
          pointerEvents: "auto",
        });
        modal.querySelector(".quiz__content").innerHTML = `
          <h3 class="title--decor rvr-modal__title">Поздравляем с&nbsp;успешной регистрацией!</h3>
          <p class="norvr-modal__p">Далее вам необходимо подтвердить заявку на&nbsp;портале &laquo;Работа в&nbsp;России&raquo; в&nbsp;течение 3&nbsp;дней.</p>
          <p class="rvr-modal__redirect">
              Через <span class="timer"> 15 </span> секунд вы будете автоматически перенаправлены на <a href="${url}" onclick="ym(74433037,'reachGoal','click_RR')">портал «Работа России»</a>
          </p>
          <p class="norvr-modal__p"><strong>Это обязательное условие для участия в&nbsp;проекте &laquo;Активные меры содействия занятости&raquo;.</strong></p>
          
          <div class="important">
            <div class="important__content">
              <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
              <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
              <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
              <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
              <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
            </div>
          </div>
          <div class="rvr-modal__bottom">
            <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ TelegramBotClick" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
            <a href="https://t.me/TGUinfoBot" class="rvr-modal__link TelegramClickSZ TelegramBotClick" rel="nofollow noopener noreferrer" target="_blank" data-bot-link>Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
          </div>
        `;

        setTimerRedirect(modal.querySelector(".timer"));
      }
      a.click();
      document.querySelector(".rvr-modal .close-modal").style.display = "none";
      telegramButtonsMetrics();

      document.querySelector("[data-bot-link]").addEventListener("click", () => {
        ym(74433037,'reachGoal','tgbot-modal-redirect')
      });
    };

    window.openModalListPrograms = (region) => {
      let data = [];

      Top5Programs.forEach((item) => {
        if (item.regionId == region) {
          data = item.programsSuggestions;
        }
      });

      if (data.length < 1) {
        openNoRedirectSaveBaseModal();
        return;
      }
      
      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        padding: "40px",
      });
      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <div class="norvr-modal__top">
            <h3 class="norvr-modal__h3">К сожалению, в&nbsp;вашем регионе программа не&nbsp;реализуется</h3>
          </div>
          <br>
          <p class="norvr-modal__p">Но вы все еще можете пройти <strong>бесплатное обучение</strong> и&nbsp;получить помощь в&nbsp;старте карьеры по другим программам. Вот какие программы доступны в&nbsp;вашем регионе:</p>
          <div class="norvr-modal__programs"></div>`;

        data.forEach((item) => {
        document.querySelector(".norvr-modal__programs").innerHTML += `
                  <a href="${item.rvrLink}" target="_blank">${item.programName}</a>
                `;
      });

      a.click();
    };

    window.openNoRedirectSuccessModal = () => {
      modal.classList.add("norvr-modal");
      setStyles(modal, {
        position: "relative",
        paddingBottom: "2rem",
        maxWidth: "500px",
      });
      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <div class="norvr-modal__top">
            <h3 class="norvr-modal__h3">Благодарим за заявку!</h3>
          </div>
          <p class="norvr-modal__p">Ваше заявление попало в <b>список приоритетных кандидатов на зачисление</b>. Мы сообщим вам о старте образовательных групп.</p>
          <p class="norvr-modal__p">
            Хорошего дня!
          </p>`;
      a.click();
    };

    window.openNoRedirectSaveBaseModal = () => {
      // const downloadLead = document.createElement("a");
      // downloadLead.href = "/files/Kak_uvelichit_dohod_v_2024_godu.pdf";
      // downloadLead.setAttribute("download", "");
      // downloadLead.style.display = "none";
      // document.body.append(downloadLead);
      // downloadLead.click();

      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        paddingBottom: "2rem",
      });
      
      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
        <h3 class="title--decor rvr-modal__title">Благодарим за заявку!</h3>
        <p class="norvr-modal__p">Ваша заявка попала в&nbsp;список приоритетных кандидатов.</p>
        <div class="important">
          <div class="important__content">
            <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
            <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
            <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
            <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
            <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
          </div>
        </div>
        <div class="rvr-modal__bottom">
          <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ TelegramBotClick" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
          <a href="https://t.me/TGUinfoBot" class="rvr-modal__link TelegramClickSZ TelegramBotClick" rel="nofollow noopener noreferrer" target="_blank" data-bot-link>Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
        </div>
      `;

      a.click();
      telegramButtonsMetrics();

      if(document.querySelector("[data-bot-link]")){
        document.querySelector("[data-bot-link]").addEventListener("click", () => {
          isJobSeeker
            ? ym(74433037,'reachGoal','tgbot-modal-employed')
            : ym(74433037,'reachGoal','tgbot-modal-other')
        });
      }
    };

    window.openNoRedirectDefaultProgramsSuccessModal = () => {
      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        paddingBottom: "2rem",
      });
      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <div class="norvr-modal__top">
            <h3 class="norvr-modal__h3">Спасибо за заявку на выбранную программу обучения!</h3>
          </div>
          <p class="norvr-modal__p">Ваша заявка в процессе рассмотрения</p>
          <p class="norvr-modal__p">Мы оповестим вас в личном сообщении на указанный email о статусе прохождения, дате старта набора в образовательные группы и пришлем вам инструкцию по дальнейшим шагам</p>`;
      a.click();
    };

    window.openAmbassadorSuccessModal = () => {
      modal.classList.add("rvr-modal");
      setStyles(modal, {
        position: "relative",
        paddingBottom: "2rem",
      });
      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
                <h3 style="margin-bottom: 1rem">
                Благодарим за заявку!
                </h3>
                <p style="margin-bottom: 1rem">Мы свяжемся с вами в ближайшее время</p>
                </div>
            `;
      a.click();
    };
  }

  /**
   * Таймер редиректа
   */
  function setTimerRedirect(el) {
    if (!el) {
      console.error("Не передан элемент");
      return;
    }
    const interval = setInterval(() => {
      if (el.textContent === "0" || Number(el.textContent) < 1) {
        clearInterval(interval);
        return;
      }
      el.textContent = Number(el.textContent) - 1;
    }, 1000);
  }

  /**
   * Начало заполнения формы
   */
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll("input, select, textarea");
    let changed = false;
    controls.forEach((control) => {
      $(control).one("blur", (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /**
   * Установка формы
   */
  function setForm(selector, small = false) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    if (selector == "#form-ambassador") {
      form.addEventListener("submit", function (e) {
        sendAmbassador(form, e, small);
      });
    } else if (selector == "#form-unsubscribe") {
      form.addEventListener("submit", function (evt) {
        sendUnsubscribe(evt);
      });
    } else {
      form.addEventListener("submit", function (e) {
        send(form, e, small);
      });

      addMaxLength(form);
      onFormFilling(form, () => {
        ym(74433037, "reachGoal", " filling");
        ym(74433037,'reachGoal','FormStartOnline');
        VK.Retargeting.Event('Initiate_Checkout');
      });
    }
  }

  /**
   * Установка максимального количества символов в полях формы
   */
  function addMaxLength(form) {
    form
      .querySelectorAll('input[type="text"], textarea')
      .forEach((control) => control.setAttribute("maxlength", "250"));
  }

  /**
   * Блокировка кнопки отправки формы
   */
  function setFormCheckbox(arr, btn) {
    try {
      arr.forEach((item) => {
        item.addEventListener("change", function () {
          if (!arr.find((checkbox) => !checkbox.checked)) {
            btn.removeAttribute("disabled");
          } else {
            btn.setAttribute("disabled", "disabled");
          }
        });
      });
    } catch (e) {}
  }

  /**
   * Событие для fbq
   */
  function setFBQ(data = null) {
    if (data && data.leadId) {
      fbq("track", "Lead", {}, { eventID: data.leadId });
    }
  }

  /**
   * Отслеживание нажатия в форме на любое поле
   */
  function clickOnForm() {
    const elementsForm = document.querySelectorAll(
      ".form__field input, .form__field select, .form__field textarea, .form__field .select2"
    );

    let result = true;

    for (let element of elementsForm) {
      element.addEventListener("click", () => {
        if (result) {
          ym(74433037, "reachGoal", "FormStart");
          ym(74433037,'reachGoal','FormStartOnline');
          result = false;
        }
      });
    }
  }
  
  /**
   * Отправка формы для отписки от рассылки
   */
  function sendUnsubscribe(evt) {
    evt.preventDefault();
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const authenticationTicket = urlParams.get("direct-crm-ticket");

    if (!authenticationTicket) return;

    const unsubscribingReason = document.querySelector("input[name='reason']:checked").value;

    const data = {
      customer: {
        authenticationTicket,
        customFields: {
          unsubscribingReason,
        },
        subscriptions: [
          {
            pointOfContact: "Email",
            isSubscribed: false
          }
        ]
      }
    };
    
    $.ajax({
      url: "https://api.mindbox.ru/v3/operations/async?endpointId=edusigma.Website2&operation=Website2.UnsubscribeCustomer",
      method: "POST",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(data),
      success: function () {
        toastr.success("Вы отписались от рассылки", "Успех!");
      },
      error: function () {
        toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          "Произошла ошибка!"
        );
      },
    });
  }

  /**
   * Отправка формы с модального окна Амбассадора
   */
  function sendAmbassador(form, e) {
    var sendBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]'
    );
    e.preventDefault();
    deleteErrors(form);
    var data = {};
    if (!validate(form)) {
      return;
    }
    sendBtn.disabled = true;
    Array.from(new FormData(form)).forEach(function (formElement) {
      var key = formElement[0];
      var value = formElement[1];

      data[key] = value;
    });

    var url = document.location.href;

    let roistatCookie = getCookie("roistat_visit");

    if (!!roistatCookie) {
      data["RoistatCookie"] = roistatCookie;
    }

    data["isNotify"] = false;
    data["ambassador"] = true;
    data["Landing"] = url.split("?")[0] || url;

    toastr.options.progressBar = true;
    $.ajax({
      url: FlowCRM,
      method: "POST",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(data),
      success: function () {
        sendBtn.disabled = false;

        openAmbassadorSuccessModal();
      },
      error: function () {
        sendBtn.disabled = false;
        toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          "Произошла ошибка!"
        );
      },
    });
  }

  /* Возвращает название региона для отправки формы */
  function returnRegionName(id, region) {
    let regionList = document.querySelectorAll(id);

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].textContent;
      }
    }
  }

  // Инициализация
  $(function () {
    setMasks();
    setForm("#form-app");
    setForm("#form-ambassador");
    setForm("#form-unsubscribe");
    setFormCheckbox(
      [
        document.querySelector("#personal-data"),
        document.querySelector("#personal-data--pd"),
      ],
      document.querySelector(".form__btn")
    );
    setFormCheckbox(
      [
        document.querySelector("#personal_data"),
        document.querySelector("#personal_data--pd"),
      ],
      document.querySelector(".form__btn-ambassador")
    );
    successModal();

    setTimeout(() => {
      clickOnForm();
    }, 2000);
  });

  /* Добавление скрипта AdvCake на сайт */
  function addAdvCakeScript(id, program, email) {
    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      pageType: 6,
      user: {
        email: `md5(${email})`,
        type: "",
      },
      leadInfo: {
        id: `${id}`,
        name: `${program}`,
        totalPrice: 0,
        coupon: "",
        marketing_cat: 1,
      },
    });
  }
};

export default send;
